import React, { Component } from 'react';
import {Grid, Row, Col, Image } from 'react-bootstrap';
import '../style.css'

class About extends Component {
  render() {
    return (
      <Grid id="section1" className="container-fluid">
            <Row id="abtdiv">
              <Col sm={8} id="abouttxt">
                <p>Front end developer from Tulsa, OK with experience in React, and jQuery with
                  back end experience in Node and Express. I am always looking for the next
                  challege so please take a look at some of my projects,
                and send me some feedback!</p>
              </Col>
              <Col sm={4} id="abtimg">
                  <Image id='img1' src="http://i.imgur.com/86jbc0Q.jpg" circle/>
              </Col>
            </Row>
      </Grid>
    )
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js